export default "__VITE_ASSET__effb42d7__"